export const SLOTS = 'slots';
export const LIVE_CASINO = 'live-casino';
export const INSTANT_GAMES = 'instant-games';
export const VIRTUAL_SPORTS = 'virtual-sports';
export const TV_GAMES = 'tv-games';
export const BINGO = 'bingo';
export const PROMO = 'promo';

export const PRODUCT_TYPES = [
  SLOTS,
  LIVE_CASINO,
  INSTANT_GAMES,
  VIRTUAL_SPORTS,
  TV_GAMES,
  BINGO,
  PROMO,
];

export const PRODUCT_NAMES_MAP = {
  [SLOTS]: 'pm-casino',
  [LIVE_CASINO]: 'live-casino',
  [INSTANT_GAMES]: 'instant-games',
  [VIRTUAL_SPORTS]: 'virtual-sports',
  [TV_GAMES]: 'tvgames',
  [BINGO]: 'bingo',
  [PROMO]: 'promo',
};

export const PRODUCT_CMS_NAMES_MAP = {
  [SLOTS]: 'pm_casino',
  [LIVE_CASINO]: 'livecasino',
  [INSTANT_GAMES]: 'instant_games',
  [VIRTUAL_SPORTS]: 'virtual_sports',
  [TV_GAMES]: 'tvgames',
  [BINGO]: 'bingo',
};

export const PRODUCT_LOCIZE_KEYS_MAP = {
  [SLOTS]: 'Slots',
  [LIVE_CASINO]: 'Live Casino',
  [INSTANT_GAMES]: 'Instant Games',
  [VIRTUAL_SPORTS]: 'Virtual Sports',
  [TV_GAMES]: 'TV Games',
  [BINGO]: 'Bingo',
};

export const PRODUCT_ANALYTICS_MAP = {
  [SLOTS]: 'slots',
  [PRODUCT_CMS_NAMES_MAP[SLOTS]]: 'slots',
  [LIVE_CASINO]: 'live_casino',
  [PRODUCT_CMS_NAMES_MAP[LIVE_CASINO]]: 'live_casino',
  [INSTANT_GAMES]: 'instant_games',
  [PRODUCT_CMS_NAMES_MAP[INSTANT_GAMES]]: 'instant_games',
  [VIRTUAL_SPORTS]: 'virtual_sports',
  [PRODUCT_CMS_NAMES_MAP[VIRTUAL_SPORTS]]: 'virtual_sports',
  [TV_GAMES]: 'tv_games',
  [PRODUCT_CMS_NAMES_MAP[TV_GAMES]]: 'tv_games',
  [BINGO]: 'bingo',
  [PRODUCT_CMS_NAMES_MAP[BINGO]]: 'bingo',
};
